if (!customElements.get("pagination")) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector(".load-more");
      this.grid = document.querySelector("[data-id=" + id + "]");
      this.animations_enabled =
        document.body.classList.contains("animations-true") &&
        typeof gsap !== "undefined";
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains("pagination-type--loadmore")) {
        this.loadMore();
      }
      if (this.classList.contains("pagination-type--infinite")) {
        this.infinite();
      }
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
      }
      if (this.scrollHandler) {
        window.removeEventListener("scroll", this.scrollHandler);
      }
    }
    addUrlParam(search, key) {
      var newParam = key + "=" + this.i,
        params = "?" + newParam;

      if (search) {
        params = search.replace(
          new RegExp("([?&])" + key + "[^&]*"),
          "$1" + newParam
        );

        if (params === search) {
          params += "&" + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener("click", function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      let scrollTimeout;

      base.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach((entry) => {
            if (
              entry.isIntersecting &&
              entry.intersectionRatio >= 0.5 &&
              !base.getAttribute("loading")
            ) {
              base.loadProducts();
            }
          });
        },
        {
          threshold: [0, 0.5, 1],
          rootMargin: "400px 0px",
        }
      );
      base.observer.observe(base);

      const scrollHandler = () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          if (base.getAttribute("loading")) return;

          const rect = base.getBoundingClientRect();
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          const nearBottom = scrollTop + windowHeight >= documentHeight - 600;

          const elementNearVisible = rect.top <= windowHeight + 600;

          if (
            (nearBottom || elementNearVisible) &&
            !base.getAttribute("loading")
          ) {
            base.loadProducts();
          }
        }, 50);
      };

      window.addEventListener("scroll", scrollHandler, { passive: true });

      base.scrollHandler = scrollHandler;
    }
    loadProducts() {
      let base = this,
        url =
          document.location.pathname +
          base.addUrlParam(document.location.search, "page");
      if (base.getAttribute("loading")) {
        return;
      }
      base.i++;
      base.setAttribute("loading", true);
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent("pagination:page-changed", {
            url: url,
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("product-grid");

      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute("loading");
        if (base.button) {
          base.button.classList.add("visually-hidden");
        }
        return;
      }
      let products = grid_to_replace.querySelectorAll(".column");

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
      }

      const finishLoading = () => {
        base.removeAttribute("loading");
        if (
          typeof StampedFn !== "undefined" &&
          typeof StampedFn.loadBadges !== "undefined"
        ) {
          StampedFn.loadBadges();
        }
        if (base.observer && !base.observer.root) {
          setTimeout(() => {
            const rect = base.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const isVisible = rect.top < windowHeight && rect.bottom > 0;
          }, 200);
        }
      };

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30,
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: finishLoading,
        });
      } else {
        finishLoading();
      }
    }
  }
  customElements.define("pagination-theme", Pagination);
}
